module.exports = __webpack_public_path__ + "static/cake_heartshaped-e6f0bc98737bc5f5ad774505c890d8c0.jpg";